<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span>{{ info.className }} 签到详情</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form :inline="true" :model="queryParams" label-width="70px">
        <el-form-item label="">
          <el-select
            v-model="queryParams.semester"
            clearable
            placeholder="选择学年学期"
            class="label"
          >
            <el-option
              v-for="item in semesterList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入学生姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker
            :picker-options="pickerOptions"
            v-model="queryParams.date"
            style="width:275px"
            type="week"
            :format="queryParams.startDate + '~' + queryParams.endDate + '第 WW 周'"
            placeholder="选择周"
        	  @change="customTimeSure"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="" style="margin-left: 20px">
          <el-button type="primary" size="small" @click="searchFun()"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>

      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="studentName" label="学生姓名" align="center">
          </el-table-column>
          <el-table-column prop="courseNum" label="报名课程数" align="center">
          </el-table-column>
          <el-table-column
            prop="needAttendanceNum"
            label="应出勤次数"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="lateNum" label="迟到次数" align="center">
          </el-table-column>
          <el-table-column prop="leaveNum" label="请假次数" align="center">
          </el-table-column>
          <el-table-column
            prop="attendanceNum"
            label="实际出勤次数"
            align="center"
          >
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
export default {
  props: ["info"],
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        name: "",
        date: "",
        startDate:'',
        endDate:'',
      },
      semesterList: [
        {id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
      ],
      tableData: [
        {studentName:'衡锦舒',courseNum:'3',needAttendanceNum:'21',lateNum:'1',leaveNum:'3',attendanceNum:'18',},
        {studentName:'范月园',courseNum:'3',needAttendanceNum:'23',lateNum:'1',leaveNum:'3',attendanceNum:'21',},
        {studentName:'杭上慧',courseNum:'3',needAttendanceNum:'25',lateNum:'1',leaveNum:'3',attendanceNum:'20',},
        {studentName:'颜婕伊',courseNum:'3',needAttendanceNum:'28',lateNum:'1',leaveNum:'3',attendanceNum:'10',},
        {studentName:'邬金无',courseNum:'3',needAttendanceNum:'25',lateNum:'1',leaveNum:'3',attendanceNum:'15',},
        {studentName:'林雁雁',courseNum:'3',needAttendanceNum:'22',lateNum:'1',leaveNum:'3',attendanceNum:'17',},
        {studentName:'晋芸姣',courseNum:'3',needAttendanceNum:'21',lateNum:'1',leaveNum:'3',attendanceNum:'18',},
        {studentName:'符薇歌',courseNum:'3',needAttendanceNum:'21',lateNum:'1',leaveNum:'3',attendanceNum:'18',},
      ],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    "info.classId": function (n, o) {
      this.pageNum = 1;
      this.getDataList();
    },
  },
  created() {},
  methods: {
    async getDataList() {
      let start = "",
        end = "";
      if (this.queryParams.date) {
        start = this.queryParams.startDate;
        end = this.queryParams.endDate;
      }
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: start,
        endDate: end,
        studentName: this.queryParams.name,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        classId: this.info.classId,
        page: this.pageNum,
        limit: this.pageSize,
      };
      // let res = await api.handleStudentAttendanceDetails(params);
      // if (res.code === "0") {
      //   this.tableData = res.data?.list || [];
      //   this.totalPage = res.data?.total || 0;
      // }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;

      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toIndex() {
      this.$emit("to-index");
    },
    // 自定义时间过滤
    customTimeSure() {
      let that = this.queryParams;
      if (that.date) {
        that.startDate = dayjs(that.date)
          .startOf("week")
          .format("YYYY-MM-DD");
        that.endDate = dayjs(that.date)
          .endOf("week")
          .format("YYYY-MM-DD");
      }
    },
  },
  mounted() {
    if(this.semesterArr && this.semesterArr.length>0){
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "第" + v.semester + "学期",
        id: v.schoolYear + "_" + v.semester,
      }));
    }
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
